// extracted by mini-css-extract-plugin
export default {"collapsible":"Request_collapsible__NKcKc","active":"Request_active__s46TI","content":"Request_content__aHX6q"};